module.exports = __webpack_public_path__ + "img/animated-ellipis.7fa6c383.gif";